// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.v-text-field--outlined {\n  font-size: 12px;\n}\n.v-text-field--outlined label {\n  font-size: 12px;\n}\n", ""]);
// Exports
module.exports = exports;
